import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export async function fetchAllOauthClients() {
    try {
        const endpoint = await RouteService.getClientsRoute();
        const response: AxiosResponse<ApiResponse<API.OauthClient[]>> = await HttpService.get(endpoint);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function fetchOauthClient(clientId: string) {
    try {
        const endpoint = await RouteService.getClientsRoute();
        const response: AxiosResponse<ApiResponse<API.OauthClient>> = await HttpService.get(endpoint + clientId);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function createOauthClient(client: API.OauthClient) {
    try {
        const endpoint = await RouteService.getClientsRoute();
        const response: AxiosResponse<ApiResponse<API.OauthClient>> = await HttpService.post(endpoint, client);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function updateOauthClient(clientId: string, client: API.OauthClient) {
    try {
        const endpoint = await RouteService.getClientsRoute();
        const response: AxiosResponse<ApiResponse<API.OauthClient>> = await HttpService.patch(endpoint + clientId, client);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function deleteOauthClient(clientId: string) {
    try {
        const endpoint = await RouteService.getClientsRoute();
        const response: AxiosResponse<ApiResponse<API.OauthClient>> = await HttpService.delete(endpoint + clientId);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}
